export default "images/tongji.png";